import type { RequestHandler as RH } from "../RequestHandler";

import Endpoints = require("../Endpoints");

import type {
	RESTGetAPIEntitlementsResult,
	RESTGetAPIEntitlementResult,
	RESTPostAPIEntitlementConsumeResult,
	RESTPostAPIEntitlementJSONBody,
	RESTPostAPIEntitlementResult,
	RESTDeleteAPIEntitlementResult
} from "discord-api-types/v10";





class EntitlementMethods {








	public constructor(public requestHandler: RH) {}












	public async getEntitlements(appId: string): Promise<RESTGetAPIEntitlementsResult> {
		return this.requestHandler.request(Endpoints.APPLICATION_ENTITLEMENTS(appId), {}, "get", "json");
	}













	public async getEntitlement(appId: string, entitlementId: string): Promise<RESTGetAPIEntitlementResult> {
		return this.requestHandler.request(Endpoints.APPLICATION_ENTITLEMENT(appId, entitlementId), {}, "get", "json");
	}













	public async consumeEntitlement(appId: string, entitlementId: string): Promise<RESTPostAPIEntitlementConsumeResult> {
		return this.requestHandler.request(Endpoints.APPLICATION_ENTITLEMENT_CONSUME(appId, entitlementId), {}, "post", "json") as Promise<RESTPostAPIEntitlementConsumeResult>;
	}

















	public async createTestEntitlement(appId: string, data: RESTPostAPIEntitlementJSONBody): Promise<RESTPostAPIEntitlementResult> {
		return this.requestHandler.request(Endpoints.APPLICATION_ENTITLEMENTS(appId), {}, "post", "json", data);
	}













	public async deleteTestEntitlement(appId: string, entitlementId: string): Promise<RESTDeleteAPIEntitlementResult> {
		return this.requestHandler.request(Endpoints.APPLICATION_ENTITLEMENT(appId, entitlementId), {}, "delete", "json") as Promise<RESTDeleteAPIEntitlementResult>;
	}
}

export = EntitlementMethods;
